<template>
  <div class="mb-6">
    <router-link class="no-underline" :to="{name: 'resource-basics', params: { id: resource.id }}">
      <img
        style="height: 218px; object-fit: cover;"
        class="rounded-lg shadow-lg"
        :alt="resource.title"
        :src="resource.image ? resource.image + '?auto=format&fit=crop&h=619&w=1024' : '/img/hems-placeholder.png'"
      />
    </router-link>

    <div class="pt-2" :class="statusClasses">
      {{statusText}}
    </div>

    <div class="resource-spacer" />

    <h3 class="text-2xl font-sans text-n-gray-dark font-hairline ">
      <router-link class="no-underline" :to="{name: 'resource-basics', params: { id: resource.id }}">
        {{resource.title}}
      </router-link>
    </h3>

    <div class="resource-spacer" />

    <p>
      {{resource.teaser}}
    </p>

  </div>
</template>

<script>
export default {
  name: "ResourceCard",
  props: {
    resource: {
      type: Object,
      required: true,
    }
  },
  computed: {
    statusText() {
      if (this.resource.published) {
        return 'Published';
      }

      switch (this.resource.status) {
        case 'draft':
          return 'Draft';
        case 'in review':
          return 'In Review';
        case 'unpublished':
          return 'Unpublished';
        default:
          return 'Other';
      }
    },
    statusClasses() {
      if (this.resource.status === 'draft' && !this.resource.published) {
        return 'text-red text-base uppercase';
      }
      return 'uppercase text-base text-gray-darker';
    }
  }
}
</script>

<style scoped>
  .resource-spacer {
    @apply mb-3;
  }
</style>